const WireService = {
    kind: 'wire',
};

export default WireService;
